module.exports = __webpack_public_path__ + "static/media/SF-logo.44bf1e71.png";